import { render, staticRenderFns } from "./EditSchool.vue?vue&type=template&id=54777768&"
import script from "./EditSchool.vue?vue&type=script&lang=js&"
export * from "./EditSchool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lee/Developer/Auris/admin-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54777768')) {
      api.createRecord('54777768', component.options)
    } else {
      api.reload('54777768', component.options)
    }
    module.hot.accept("./EditSchool.vue?vue&type=template&id=54777768&", function () {
      api.rerender('54777768', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schools/EditSchool.vue"
export default component.exports